import COUNTRIES from '../countries.translations'

import translations from './lithium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/lithium'

export const lithium: Metal = {
  id: 3,
  slug: 'lithium',
  name: t.name,
  symbol: 'Li',
  // Already matching the sheet's four pins: two hard-rock mines in Australia, two brine
  // salars in South America — the two extraction routes the copy contrasts.
  mines: [
    {
      name: 'Greenbushes (Australia, Talison/Albemarle/Tianqi)',
      region: t.mine0Region,
      slug: 'greenbushes',
      coordinates: [116.05, -33.85],
    },
    {
      name: 'Pilgangoora (Australia, Pilbara Minerals)',
      region: t.mine1Region,
      slug: 'pilgangoora',
      coordinates: [118.38, -21.28],
    },
    {
      name: 'Salar de Atacama (Chile, SQM & Albemarle)',
      region: t.mine2Region,
      slug: 'salar-de-atacama',
      coordinates: [-68.25, -23.48],
    },
    {
      name: 'Salar de Olaroz (Argentina, Lithium Americas)',
      region: t.mine3Region,
      slug: 'salar-de-olaroz',
      coordinates: [-66.52, -23.6],
    },
    {
      name: 'Cornwall (United Kingdom)',
      region: t.mine4Region,
      slug: 'cornwall',
      coordinates: [-4.88, 50.38],
    },
  ],
  // Eight, as the sheet lists them — the longest set of any metal so far, and the point
  // its geopolitical copy makes: lithium mining is unusually well distributed.
  countries: [
    { name: COUNTRIES.australia, percent: 36.7 },
    { name: COUNTRIES.chile, percent: 20.4 },
    { name: COUNTRIES.china, percent: 17.1 },
    { name: COUNTRIES.zimbabwe, percent: 9.2 },
    { name: COUNTRIES.argentina, percent: 7.5 },
    { name: COUNTRIES.brazil, percent: 4.2 },
    { name: COUNTRIES.canada, percent: 1.8 },
    { name: COUNTRIES.namibia, percent: 1.1 },
  ],
  important: true,
  // The sheet names one: copper — paired by the electrification story rather than by
  // geology. Copper's own sheet points back at lithium, so the pair is reciprocal.
  related: ['copper'],
  video: {
    name: 'lithium',
    poster: '/mine-my-phone/images/posters/lithium.jpg',
  },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 3,
      quantityLabel: t.smartphone.label,
      parts: ['battery'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 2, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 3, ...t.supplyRisk },
    recycling: { score: 2, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
        credit: 'Picture Alliance / Getty',
      },
      firstBento: [
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
          credit: 'Courtesy',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'vertical',
          credit: 'Courtesy',
        },
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
      secondBento: [
        {
          src: `${dir}/05.jpg`,
          orientation: 'horizontal',
          credit: 'Courtesy',
        },
        {
          src: `${dir}/06.jpg`,
          orientation: 'vertical',
          credit: 'Diego Bravo',
        },
        {
          src: `${dir}/07.jpg`,
          orientation: 'vertical',
          credit: 'Paula Díaz Levi',
        },
        {
          src: `${dir}/08.jpg`,
          orientation: 'horizontal',
          credit: 'Paula Díaz Levi',
        },
      ],
    },
  },
}
